import React from 'react'
import styled from 'styled-components';
import Link from "../Link";

export const AuthorDiv = styled.div`
  background: #fff;
  border-radius: 5px;
  border-color: #eee;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  font-family: Poppins, Helvetica, Arial, sans-serif;
  margin: 0 0 20px 0;
  width: 100%;
  h1 {
    font-size: 16px;
    font-weight: 600;
    margin: 0 !important;
    color: #000  !important;
    font-family: Poppins, Helvetica, Arial, sans-serif;

    > a {
        font-size: 16px !important;
        font-weight: 600 !important;
        color:  #e01efe !important;

         &:hover {
            color: #9b05a8 !important;
         }
    }
  }
  p {
    font-size: 14px !important;
    margin: 0 !important;
    color: #000 !important;
    font-family: Poppins, Helvetica, Arial, sans-serif !important;
  }
  .auth-avatar {
    border-radius: 50% !important;
	border: 5px solid #fff !important;
    box-shadow: 0px 0px 7px 1px rgba(0,0,0,0.2) !important;
	width: 50px !important;
	height: 50px !important;
    margin: 0 0 0 5px !important;
    object-fit: cover !important;
  }
  a {
    color: #e01efe !important;
    font-size: 12px !important;
  }
    @media (max-width: 768px) {
        // max-width: 300px !important;
        width: 90%;
    }
`;

const AuthorData = styled.div`
    display: flex;
    margin: 10px 0;
    align-items: flex-start;
    justify-content: center;
`;
const NameAndRoleInfo = styled.div`
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    @media (max-width: 768px) {
        max-width: 100%;
    }
`;

const AboutText = styled.span`
    margin-right: 5px;
`
const SMLogo = styled.img`
	width: 18px !important;
	height: 18px !important;
	border: none !important;
    margin: 0 !important;
`;
const SM = styled.div`
    width: 25px !important;
    height: 25px !important;
    display:flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 5px;
    background-color: #b0b9c4;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    &:hover {
        background-color: #1D9BF0 !important;
    }
    margin-top: 5px;
`;
const Separator = styled.div`
    width: 100%;
    height: 1px;
    background-color: #eee;
    margin: 5px 0;
`;

const InPostAuthorSection = ({ name, role, expertise, authorsPage, avatar, socialMedia }) => {
    const twitterLink = socialMedia.filter(item => item.includes("twitter"))[0]
    return (
        <AuthorDiv >
            <Separator />

            <div>
                <AuthorData>
                    <img className='auth-avatar' src={avatar} />
                    <NameAndRoleInfo>
                        <h1>By <Link to={authorsPage}>{name}</Link></h1>
                        {/* <p style={{ fontWeight: "600" }}>{role}</p> */}
                        <p><AboutText>{name.split(" ")[0]} writes about {expertise?.toLowerCase()}.</AboutText>
                            {twitterLink && <span><Link to={twitterLink}><SM>
                                <SMLogo src="https://donotpay-assets.s3.us-west-2.amazonaws.com/authTwitter.png" style={{ border: "none" }} />
                            </SM></Link></span>}
                        </p>
                    </NameAndRoleInfo>
                </AuthorData>
                <div style={{ width: "100%", textAlign: "right" }}>
                </div>
            </div>
        </AuthorDiv>
    )
}

export default InPostAuthorSection